
  var path = 'scripts/segment-inputs-config/address/jk/typeahead-item.tpl.jade';
  var html = "<a class=\"jk-typeahead-item\"><div class=\"jk-typeahead-item__multiline\"><cian-af-jk-preview-typeahead item=\"match.model\"></cian-af-jk-preview-typeahead></div></a>";
  window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
  module.exports = path;
  